import 'bootstrap/dist/css/bootstrap.min.css';

import '@styles/main.scss';

import editorService from './services/editorService';
import filePondService from './services/filePondService';

import 'bootstrap';
import { initConfirmModal } from './helpers/confirmModal';
import initWinesTabs from './helpers/winesTabs';
import initQuantitySelectors from './helpers/quantitySelector';
import initTooltips from './helpers/tooltips';
import initPasswordToggles from './helpers/passwordToggle';
import initPasswordRequirements from './helpers/passwordRequirements';
import initClientTypeToggle from './helpers/clientTypeToggle';
import initColorPickerFields from './helpers/colorPickerField';
import initInlineEdit from './helpers/inlineEdit';
import initAppellationAutocomplete from './helpers/appellationAutocomplete';
import initOrderLines from './helpers/orderLines';
import initOrderRates from './helpers/orderRates';
import initCart from './services/cart';
import initQuickAddBar from './services/quickAddBar';

// Expose services immediately when the bundle executes.
window.services = window.services || {};
window.services.editorService = editorService;
window.services.filePondService = filePondService;

initConfirmModal();
initWinesTabs();
initQuantitySelectors();
initTooltips();
initPasswordToggles();
initPasswordRequirements();
initClientTypeToggle();
initColorPickerFields();
initInlineEdit();
initAppellationAutocomplete();
initOrderLines();
initOrderRates();
initCart();
initQuickAddBar();

// Toast notifications — auto-dismiss after 5s
document.querySelectorAll('[data-toast]').forEach((toast) => {
    requestAnimationFrame(() => toast.classList.add('is-visible'));

    const dismiss = () => {
        toast.classList.remove('is-visible');
        toast.addEventListener('transitionend', () => toast.remove(), { once: true });
    };

    toast.querySelector('[data-toast-close]')?.addEventListener('click', dismiss);
    setTimeout(dismiss, 5000);
});